import React from "react";

// Pill-shaped label chip, mirroring Android's LabelChip. Selected = filled with
// the label color + white text; unselected = transparent with a colored outline.
const LabelChip = ({ name, color, selected = true, onClick }) => {
  const c = color || "#7C8DB5";
  return (
    <span
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: "999px",
        border: `1px solid ${c}`,
        backgroundColor: selected ? c : "transparent",
        color: selected ? "#fff" : c,
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {name}
    </span>
  );
};

export default LabelChip;
